import React, { Fragment } from "react";
import { Link } from "react-router-dom";

const TermsAndConditions = () => {
  return (
    <Fragment>
      <section
        className="page-banner-sec text-center"
        style={{
          backgroundImage: `url("../assets/frontend/img/about-banner.jpg")`,
        }}
      >
        <div className="container">
          <ul className="clearfix paginations-cust">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>Terms and Conditions</li>
          </ul>
          <h1>Terms and Conditions</h1>
        </div>
      </section>

      <section className="cms-content-sec">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div style={{ padding: "30px 0" }}>
                <p>
                  <strong>Effective Date:</strong> 12/12/2025
                </p>

                <p>
                  Welcome to One Time Success! These Terms and Conditions govern
                  your use of our educational app. By accessing or using the app,
                  you agree to be bound by these terms. If you do not agree with
                  any part of these terms, you must not use the app.
                </p>

                <h3>1. Acceptance of Terms</h3>
                <p>
                  By downloading or using One Time Success you acknowledge that
                  you have read, understood, and agree to these Terms and
                  Conditions. If you are using the app on behalf of an
                  organization, you represent that you are authorized to accept
                  these Terms on behalf of that organization.
                </p>

                <h3>2. Use of the App</h3>
                <ul>
                  <li>
                    <strong>Eligibility:</strong> You must be at least 13 years
                    old to use this app. If you are under 13, you may only use
                    the app with parental consent.
                  </li>
                  <li>
                    <strong>License:</strong> We grant you a limited,
                    non-exclusive, non-transferable license to use the app on
                    your personal mobile device, in accordance with these Terms.
                  </li>
                </ul>

                <h3>3. User Accounts</h3>
                <ul>
                  <li>
                    <strong>Account Creation:</strong> To access certain features
                    of the app, you may need to create an account. You must
                    provide accurate and complete information during the
                    registration process and keep your account information up to
                    date.
                  </li>
                  <li>
                    <strong>Security:</strong> You are responsible for
                    maintaining the confidentiality of your account login
                    information and for all activities that occur under your
                    account. Notify us immediately of any unauthorized use.
                  </li>
                </ul>

                <h3>4. User Content</h3>
                <ul>
                  <li>
                    <strong>Responsibility for Content:</strong> You are solely
                    responsible for any content you create, upload, or share
                    through the app. You must not upload any content that
                    violates any third-party rights, is illegal, or is otherwise
                    inappropriate.
                  </li>
                  <li>
                    <strong>License to Use Content:</strong> By submitting
                    content to the app, you grant us a non-exclusive,
                    royalty-free, perpetual, and worldwide license to use,
                    reproduce, modify, and publish that content.
                  </li>
                </ul>

                <h3>5. Prohibited Activities</h3>
                <p>
                  You agree not to engage in any of the following prohibited
                  activities:
                </p>
                <ul>
                  <li>
                    Using the app for any illegal or unauthorized purpose.
                  </li>
                  <li>
                    Interfering with or disrupting the app or servers or networks
                    connected to the app.
                  </li>
                  <li>
                    Attempting to gain unauthorized access to the app, other user
                    accounts, or computer systems.
                  </li>
                </ul>

                <h3>6. Intellectual Property</h3>
                <p>
                  All intellectual property rights in the app, including but not
                  limited to the design, graphics, text, and software, are owned
                  by One Time Success or its licensors. You may not reproduce,
                  distribute, modify, or create derivative works from any part of
                  the app without prior written consent.
                </p>

                <h3>7. Disclaimer</h3>
                <ul>
                  <li>
                    <strong>No Warranty:</strong> The app is provided "as is" and
                    "as available" without any warranties of any kind, either
                    express or implied. We do not warrant that the app will be
                    uninterrupted or error-free.
                  </li>
                  <li>
                    <strong>Limitation of Liability:</strong> To the fullest
                    extent permitted by law, One Time Success and its affiliates
                    shall not be liable for any indirect, incidental, special, or
                    consequential damages arising out of or in connection with
                    your use of the app.
                  </li>
                </ul>

                <h3>8. Termination</h3>
                <p>
                  We reserve the right to suspend or terminate your access to the
                  app at any time, without notice, for conduct that we believe
                  violates these Terms or is harmful to other users or the app.
                </p>

                <h3>9. Changes to Terms</h3>
                <p>
                  We may update these Terms and Conditions from time to time. We
                  will notify you of any changes by posting the new Terms on this
                  page. Your continued use of the app after any changes will
                  constitute your acceptance of the new Terms.
                </p>

                <h3>10. Governing Law</h3>
                <p>
                  These Terms shall be governed by and construed in accordance
                  with the laws of Anambra State, Nigeria without regard to its
                  conflict of law principles.
                </p>

                <h3>11. Contact Us</h3>
                <p>
                  If you have any questions about these Terms and Conditions,
                  please contact us by email:{" "}
                  <a href="mailto:info@onetimesuccess.com">
                    info@onetimesuccess.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default TermsAndConditions;
